import { Radio as RadioComponent } from './ui/Radio/Radio'
import { RadioButton } from './ui/RadioButton/RadioButton'
import { RadioGroup } from './ui/RadioGroup/RadioGroup'

const Radio = Object.assign(RadioComponent, {
	Group: RadioGroup,
	Button: RadioButton
})

export { Radio }
